import { render } from "./stackholder-dashboard.vue?vue&type=template&id=1ae0b8fd"
import script from "./stackholder-dashboard.vue?vue&type=script&lang=js"
export * from "./stackholder-dashboard.vue?vue&type=script&lang=js"

import "./stackholder-dashboard.vue?vue&type=style&index=0&id=1ae0b8fd&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__